import axios from "@util/axios";

class GRecaptchaService {
	async verifyResponse(response) {
		const rs = await axios({
			url: `/recaptcha/verify`,
			method: "POST",
			data: {
				response: response,
			},
		});

		return rs;
	}
}

export default new GRecaptchaService();
